import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'brightside-web-financial-accounts-external-account',
    templateUrl: './financial-accounts-external-account.component.html',
    styleUrls: ['./financial-accounts-external-account.component.css'],
    standalone: false
})
export class FinancialAccountsExternalAccountComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
